import { createDebugger } from '@iotize/common/debug';

const prefix = '@iotize/tap/gpio';

export const debug = createDebugger(prefix);
